'use client'

import HeaderWithBackButton from '@/components/common/HeaderWithBackButton'
import { INotice } from '@/types/pages'
import Image from 'next/image'
import { useTranslation } from 'react-i18next'
import { GA_EVENTS } from '@/utils/analytics'
import { useEffect } from 'react'

interface INoticeDetailProps {
  notice: INotice
}

const NoticeDetail: React.FC<INoticeDetailProps> = ({ notice }) => {
  const { t } = useTranslation('notice')

  useEffect(() => {
    GA_EVENTS.NOTICE_VIEW(notice.title)
  }, [notice.title])

  return (
    <section className='sm:mt-5'>
      <div className='sm:hidden'>
        <HeaderWithBackButton />
      </div>
      <div className="mx-auto flex flex-col gap-3 px-5 max-w-lg">
        <div className="flex flex-col gap-3">
          <p className="py-1 px-2 mr-auto text-[11px] font-pretendard-semibold text-white dark:text-black bg-main-light-2 dark:bg-main-dark-2 rounded-md">
            {t(notice.category)}
          </p>
          <h2 className="font-pretendard-semibold text-[19px] text-main-light-2 dark:text-main-dark-2 leading-tight">
            {notice.title}
          </h2>
          <Image src={notice.image} alt="notice" width={327} height={188} className='w-full rounded-lg'/>
          <p className="font-pretendard-regular text-[15px] text-main-light-2 dark:text-main-dark-2">
            {notice.description}
          </p>
          <p className="font-pretendard-regular text-[13px] text-main-light-4 dark:text-main-dark-4">
            {notice.createdAt}
          </p>
        </div>
      </div>
    </section>
  )
}

export default NoticeDetail
